const ADJACENT = {
  pigment:  [{code:'5208',name:'Heather',hex:'#AD57AD'},{code:'5010',name:'Pink Lavender',hex:'#F9B4E4'},{code:'5339',name:'Capri Blue',hex:'#68D2F2'},{code:'5351',name:'Lime Sorbet',hex:'#CEF7AA'},{code:'5347',name:'Biscayne',hex:'#2FD3B8'},{code:'5234',name:'Periwinkle',hex:'#A2B7F2'}],
  orchard:  [{code:'5163',name:'Auburn',hex:'#603526'},{code:'5206',name:'Berry Sorbet',hex:'#BA5097'},{code:'5219',name:'Radiant Orchid',hex:'#B330C6'},{code:'5232',name:'Mauve Mist',hex:'#B26F97'},{code:'5258',name:'Violet Ice',hex:'#C2A6ED'},{code:'5441',name:'Pale Jade',hex:'#B3CCAA'}],
  heatwave: [{code:'5094',name:'Electric Fuschia',hex:'#D32043'},{code:'5111',name:'Poppy',hex:'#B71100'},{code:'5148',name:'Burnt Sienna',hex:'#9E590E'},{code:'5117',name:'Harvest Gold',hex:'#DDA026'},{code:'5090',name:'Coral Reef',hex:'#ED692F'},{code:'5083',name:'Tigerlily',hex:'#D34D1E'}],
  tidal:    [{code:'5272',name:'Placid Blue',hex:'#B7E0F9'},{code:'5302',name:'Pacific Teal',hex:'#05A7D3'},{code:'5304',name:'Adriatic',hex:'#007C99'},{code:'5332',name:'Blue Yonder',hex:'#4769C9'},{code:'5365',name:'Key Largo',hex:'#80CFCA'},{code:'5340',name:'Mint Ice',hex:'#B5F4E4'}],
  prairie:  [{code:'5133',name:'Cinnamon Spice',hex:'#773D26'},{code:'5191',name:'Pale Gold',hex:'#CCAD8B'},{code:'5030',name:'Peach Cobbler',hex:'#FFCCB0'},{code:'5096',name:'Sandcastle',hex:'#F0DEC0'},{code:'5138',name:'Desert Wheat',hex:'#C4A67A'},{code:'5137',name:'Warm Straw',hex:'#E5C283'}],
  canopy:   [{code:'5377',name:'Deep Forest',hex:'#0F4723'},{code:'5395',name:'Olive Oil',hex:'#5F7715'},{code:'5388',name:'Dark Olive',hex:'#444905'},{code:'5451',name:'Forest Shade',hex:'#406043'},{code:'5418',name:'Roasted Coffee',hex:'#513F11'},{code:'5386',name:'Dried Herb',hex:'#A6A852'}]
};

document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);

  if (params.get('ref') !== 'qr') {
    window.location.href = '/';
    return;
  }

  var pack = (params.get('pack') || '').toLowerCase();
  var packColors = ADJACENT[pack];

  if (!packColors) {
    window.location.href = '/';
    return;
  }

  var voteMain = document.getElementById('vote-main');
  var colorsUrl = voteMain.dataset.colorsUrl;

  // Fetch thread-colors.json, build byCode lookup, then render
  fetch(colorsUrl)
    .then(function (res) { return res.json(); })
    .catch(function () { return []; })
    .then(function (allColors) {
      var byCode = {};
      allColors.forEach(function (c) { byCode[c.code] = c; });
      init(byCode);
    });

  function init(byCode) {
    voteMain.style.display = '';
    document.getElementById('vote-title').textContent = pack.toUpperCase();
    document.getElementById('field-pack').value = pack;

    var container = document.getElementById('vote-cards');
    var selected = new Set();

    packColors.forEach(function (color) {
      // HVST data comes from byCode lookup, not hardcoded
      var meta = byCode[color.code] || {};

      var card = document.createElement('div');
      card.className = 'vote-card';
      card.dataset.code = color.code;
      card.style.transition = 'transform 0.15s ease, box-shadow 0.15s ease';

      var colorArea = document.createElement('div');
      colorArea.className = 'vote-card-color';
      colorArea.style.background = color.hex;

      var label = document.createElement('div');
      label.className = 'vote-card-label';

      var name = document.createElement('div');
      name.className = 'vote-card-name';
      name.textContent = color.name;

      var code = document.createElement('div');
      code.className = 'vote-card-code';
      code.textContent = color.code;

      label.appendChild(name);
      label.appendChild(code);
      card.appendChild(colorArea);
      card.appendChild(label);

      card.addEventListener('click', function () {
        if (selected.has(color.code)) {
          selected.delete(color.code);
          card.style.transform = 'scale(1)';
          card.style.boxShadow = 'none';
          card.style.zIndex = '1';
        } else {
          selected.add(color.code);
          card.style.transform = 'scale(1.08)';
          card.style.boxShadow = 'inset 0 0 0 3px #ffffff';
          card.style.zIndex = '10';
        }
      });

      container.appendChild(card);
    });

    var form = document.getElementById('vote-form');
    var submitBtn = document.getElementById('vote-submit');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = document.getElementById('vote-email').value;
      var colors = Array.from(selected).join(', ') || 'none selected';
      document.getElementById('field-colors').value = colors;

      // Show thank you immediately — don't wait for network
      document.getElementById('vote-main').style.display = 'none';
      var ty = document.getElementById('vote-thankyou');
      ty.removeAttribute('style');
      ty.style.cssText = 'display:flex; position:fixed; inset:0; background:#1a1a1a; z-index:9999; flex-direction:column; align-items:center; justify-content:center; padding:48px; text-align:center;';
      var tyEmail = document.getElementById('ty-email');
      if (tyEmail) tyEmail.textContent = email;

      // Submit to Formspree in background
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      }).catch(function () {});
    });
  }
});
